import types from '@/store/faq/types';
import apiCall from '@/store/apiCall';
import URLS from '@/store/urls';
import notificationWithIcon from '@/utils/notification';

const actions = {
  async getFAQByPage({ commit }, payload) {
    try {
      commit(types.GET_FAQ_BY_PAGE_START);
      const {
        path,
      } = payload;
      const { data: { data: faq } } = await apiCall({
        type: 'GET',
        url: `${URLS.frequentlyAskedQuestions}/${path}`,
        isToken: true,
      });
      commit(types.GET_FAQ_BY_PAGE_SUCCESS, faq);
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
      commit(types.GET_FAQ_BY_PAGE_FAILURE, message);
    }
  },

  async editFAQ({ dispatch }, payload) {
    try {
      const {
        id,
        body,
        path,
      } = payload;
      await apiCall({
        type: 'PUT',
        url: `${URLS.frequentlyAskedQuestions}/${id}`,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'FAQ updated');
      dispatch('getFAQByPage', { path });
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
  async createFAQ({ dispatch }, payload) {
    try {
      const {
        body,
        path,
      } = payload;
      await apiCall({
        type: 'POST',
        url: `${URLS.frequentlyAskedQuestions}`,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'FAQ created');
      dispatch('getFAQByPage', { path });
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
  async editFAQOrderIndexAction({ dispatch }, payload) {
    try {
      const {
        body,
        path,
      } = payload;
      await apiCall({
        type: 'PATCH',
        url: `${URLS.frequentlyAskedQuestions}/change-position`,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'Positions updated');
      dispatch('getFAQByPage', { path });
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
  async deleteFAQAction({ dispatch }, payload) {
    try {
      const {
        id,
        path,
      } = payload;
      await apiCall({
        type: 'DELETE',
        url: `${URLS.frequentlyAskedQuestions}/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'FAQ deleted');
      dispatch('getFAQByPage', { path });
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
  async getTemplatesFAQ({ commit }) {
    try {
      commit(types.GET_FAQ_TEMPLATES_START);
      const { data: { data: faq } } = await apiCall({
        type: 'GET',
        url: URLS.frequentlyAskedQuestionsTemplate,
        isToken: true,
      });
      commit(types.GET_FAQ_TEMPLATES_SUCCESS, faq);
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
      commit(types.GET_FAQ_TEMPLATES_FAILURE, message);
    }
  },
  async editTemplateFAQ({ dispatch }, payload) {
    try {
      const {
        id,
        body,
      } = payload;
      await apiCall({
        type: 'PUT',
        url: `${URLS.frequentlyAskedQuestionsTemplate}/${id}`,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'FAQ updated');
      dispatch('getTemplatesFAQ');
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
  async createTemplateFAQ({ dispatch }, payload) {
    try {
      const {
        body,
      } = payload;
      await apiCall({
        type: 'POST',
        url: `${URLS.frequentlyAskedQuestionsTemplate}`,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'FAQ created');
      dispatch('getTemplatesFAQ');
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
  async deleteTemplateFAQ({ dispatch }, payload) {
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.frequentlyAskedQuestionsTemplate}/${payload}`,
        isToken: true,
      });
      notificationWithIcon('success', 'FAQ deleted');
      dispatch('getTemplatesFAQ');
    } catch (e) {
      const {
        response: {
          data: {
            message: serverMessage = '',
          } = {},
        } = {},
        message: axiosMessage,
      } = e || {};
      const message = serverMessage || axiosMessage || '';
      notificationWithIcon('error', message);
    }
  },
};

export default actions;
